<template>
  <div id="classroomForm" class="form">
    <v-alert type="warning" v-if="globalCenter && !globalCenter.id">Choose a location first</v-alert>
    <v-form v-if="loaded" ref="form" v-model="valid" lazy-validation>
      <v-text-field
        v-model="classroom.roomNumber"
        label="Room Number/Name"
        :required="true"
      />
      <v-textarea
        outlined
        v-model="classroom.description"
        label="Description"
        :rows="3"
      />

      <div class="mt-4 d-flex justify-space-between">
        <v-btn @click="goBack"> Back </v-btn>
        <v-btn @click="handleSubmit" color="primary">
          {{ id ? "Update" : "Save" }}
        </v-btn>
        <span></span>
      </div>
    </v-form>
  </div>
</template>
    
<script>
import { getClassroom } from "@/services/classroom";

import { mapActions, mapGetters } from "vuex";

export default {
  props: ["id"],
  data() {
    return {
      loaded: false,
      valid: false,
      classroom: {
        relations: {},
        roomNumber: "",
        description: "",
      },
    };
  },
  created() {
    this.setInstance();
  },
  computed: {
    ...mapGetters("navigation", ["isAppLoading", "globalCenter"]),

  },
  methods: {
    ...mapActions("classroom", ["createClassroom", "updateClassroom"]),
    ...mapActions("messages", [
      "addMessage",
      "addErrorMessage",
      "addSuccessMessage",
    ]),

    async handleSubmit() {
      if (this.id) {
        let classroom = this.classroom;
        delete classroom.relations;

        this.updateClassroom(classroom)
          .then((response) => {
            console.log(response);
            this.addSuccessMessage("Classroom was updated successfully");
            this.goBack();
          })
          .catch(() => {
            this.addErrorMessage(
              "Error updating Classroom, please try again later"
            );
          });
      } else {
        let classroom = this.classroom;
        delete classroom.relations;

        this.createClassroom(classroom)
          .then((response) => {
            console.log(response);
            this.addSuccessMessage("Classroom was created successfully");
            this.goBack();
          })
          .catch(() => {
            this.addErrorMessage(
              "Error creating Classroom, please try again later"
            );
          });
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    setInstance() {
      if (this.id) {
        this.classroom.id = this.id;
        getClassroom(this.id).then((response) => {
          let instance = response.data;
          for (let property in instance) {
            if (
              Object.prototype.hasOwnProperty.call(instance, property) &&
              Object.prototype.hasOwnProperty.call(this.classroom, property)
            ) {
              this.classroom[property] = instance[property];
            }
          }
          this.loaded = true;
        });
      } else {
        this.loaded = true;
      }
      this.setDependencies();
    },
    setDependencies() {},
  },
  components: {},
};
</script>
